import { render, staticRenderFns } from "./TerminalRequestDSRView.vue?vue&type=template&id=04f78a88&scoped=true&"
import script from "./TerminalRequestDSRView.vue?vue&type=script&lang=js&"
export * from "./TerminalRequestDSRView.vue?vue&type=script&lang=js&"
import style0 from "./TerminalRequestDSRView.vue?vue&type=style&index=0&id=04f78a88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f78a88",
  null
  
)

export default component.exports